"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyLimits = void 0;
var SurveyLimits;
(function (SurveyLimits) {
    let Description;
    (function (Description) {
        Description.MaxLength = 2000;
    })(Description = SurveyLimits.Description || (SurveyLimits.Description = {}));
    let Recipients;
    (function (Recipients) {
        Recipients.Max = 50;
        Recipients.Min = 1;
    })(Recipients = SurveyLimits.Recipients || (SurveyLimits.Recipients = {}));
    let DeliverAt;
    (function (DeliverAt) {
        /**
         * ISO 8601 Duration
         */
        DeliverAt.MaxDurationFromNow = "P3M";
    })(DeliverAt = SurveyLimits.DeliverAt || (SurveyLimits.DeliverAt = {}));
    let CloseAt;
    (function (CloseAt) {
        /**
         * ISO 8601 Duration
         */
        CloseAt.MaxDurationFromDelivery = "P3M";
        /**
         * ISO 8601 Duration
         */
        CloseAt.MinDurationFromDelivery = "PT5M";
    })(CloseAt = SurveyLimits.CloseAt || (SurveyLimits.CloseAt = {}));
    let Questions;
    (function (Questions) {
        let Label;
        (function (Label) {
            Label.MaxLength = 5000;
            Label.MinLength = 3;
        })(Label = Questions.Label || (Questions.Label = {}));
        Questions.Max = 50;
        Questions.Min = 1;
        let Choices;
        (function (Choices) {
            Choices.Max = 25;
            Choices.Min = 2;
            let Value;
            (function (Value) {
                Value.MaxLength = 2000;
                Value.MinLength = 1;
            })(Value = Choices.Value || (Choices.Value = {}));
            let Label;
            (function (Label) {
                Label.MaxLength = 2000;
                Label.MinLength = 1;
            })(Label = Choices.Label || (Choices.Label = {}));
        })(Choices = Questions.Choices || (Questions.Choices = {}));
        let OpenEnded;
        (function (OpenEnded) {
            let Value;
            (function (Value) {
                Value.MaxLength = 3000;
                Value.MinLength = 1;
            })(Value = OpenEnded.Value || (OpenEnded.Value = {}));
        })(OpenEnded = Questions.OpenEnded || (Questions.OpenEnded = {}));
    })(Questions = SurveyLimits.Questions || (SurveyLimits.Questions = {}));
    let Title;
    (function (Title) {
        //Poll questions get copied to survey title, so lengths need to match
        Title.MaxLength = Questions.Label.MaxLength;
        Title.MinLength = 3;
    })(Title = SurveyLimits.Title || (SurveyLimits.Title = {}));
    let Comment;
    (function (Comment) {
        Comment.MaxLength = 3000;
    })(Comment = SurveyLimits.Comment || (SurveyLimits.Comment = {}));
    let CommentAppeal;
    (function (CommentAppeal) {
        CommentAppeal.MaxLength = 200;
    })(CommentAppeal = SurveyLimits.CommentAppeal || (SurveyLimits.CommentAppeal = {}));
    let Reminders;
    (function (Reminders) {
        Reminders.Max = 2;
    })(Reminders = SurveyLimits.Reminders || (SurveyLimits.Reminders = {}));
})(SurveyLimits = exports.SurveyLimits || (exports.SurveyLimits = {}));
//# sourceMappingURL=SurveyLimits.js.map